import { TableStructure } from "../components/TableStructure";


const List = [
  {
    fileStoreId: "e7c06068-55ca-4224-8878-d05ce71161f9",
    label: "PURASHREE [BENGALI] :16 AUGUST - 31 AUGUST 2015",
  },
  {
    fileStoreId: "94a474a0-71aa-494f-a41c-ea90d0c505b6",
    label: "PURASHREE [BENGALI] :1 AUGUST - 15 AUGUST 2015",
  },
  {
    fileStoreId: "002f13c1-4588-4fc2-a386-4cef4359a97c",
    label: "PURASHREE [BENGALI] :16 JULY - 31 JULY 2015",
  },
  { fileStoreId: "4a5c21f0-546c-410e-85d3-fd1d632eca2e", label: "PURASHREE [BENGALI] :1 JULY - 15 JULY 2015" },
  {
    fileStoreId: "5b4b920d-dfe9-4e46-a5e8-df310846f202",
    label: "Puroshree Election Issue Book 2015",
  },
  {
    fileStoreId: "7192593a-9372-4df2-ae20-0e59078d602f",
    label: "PURASHREE [BENGALI] :FEBRUARY 2015",
  },
  {
    fileStoreId: "56c6ee72-a949-4271-8805-e98251f06059",
    label: "PURASHREE [BENGALI] :JANUARY 2015",
  },
  {
    fileStoreId: "9c365e29-d902-44fe-96f0-a6509276fcd8",
    label: "PURASHREE [BENGALI] :OCTOBER - DECEMBER 2014",
  },
  {
    fileStoreId: "6607d3a5-9c53-4c92-b589-6dc9154fd96d",
    label: "PURASHREE [BENGALI] :JUNE - AUGST 2014",
  },
  {
    fileStoreId: "abee3e77-bad2-48cd-a4b3-8d931027a004",
    label: "PURASHREE [BENGALI] :MAY 2014",
  },
  {
    fileStoreId: "76aa95ff-ca47-40fb-8961-8e97c492d332",
    label: "PURASHREE [BENGALI] :MARCH - APRIL 2014",
  },
  {
    fileStoreId: "23687669-e273-4638-9a43-070212f6b512",
    label: "PURASHREE [BENGALI] :JANUARY - FEBRUARY 2014",
  },
  {
    fileStoreId: "4cf5d514-1605-4beb-8bac-8ad1d662d6f2",
    label: "PURASHREE [BENGALI] :DECEMBER 2013",
  },
  {
    fileStoreId: "a9fa9953-1181-416d-b61b-8a63309e0aea",
    label: "PURASHREE [BENGALI] :OCTOBER - NOVEMMBER 2013",
  },
  {
    fileStoreId: "313cd46b-d6bd-4d34-92e7-a81efc6cf9c6",
    label: "REPORT ON KANYASHREE PRAKALPA AND KANYASHREE MELA",
  },
  {
    fileStoreId: "2c1a8528-cb5d-4f01-96ad-012b477df890",
    label:
      "CSR Report from Parks and Square department for maintenance by Corporate Authority",
  },
  { fileStoreId: "d58cd921-a97b-4b2e-9a26-343ca3d9ad8a", label: "e Office" },
  {
    fileStoreId: "8996f662-3ebb-42de-bd96-072f3e6178c9",
    label: "PURASHREE [BENGALI] : JULY-AUGUST 2013",
  },
  {
    fileStoreId: "b5b63b40-c353-49ba-a5c9-53eea108a540",
    label: "PURASHREE [BENGALI] : JUNE 2013",
  },
  {
    fileStoreId: "ed7a3473-ea13-402a-8e2a-4260a6f443b0",
    label: "PURASHREE [BENGALI] : MARCH-APRIL 2013",
  },
  {
    fileStoreId: "5af262c4-919d-4819-a809-cc87c642720b",
    label: "PURASHREE [BENGALI] : FEBRUARY 2013",
  },
  {
    fileStoreId: "a99820a5-72f3-49c2-ba39-d004e6b6aff3",
    label: "PURASHREE [BENGALI] : NOVEMMBER - DECEMBER 2012",
  },
  {
    fileStoreId: "07d210c1-c9ae-49b0-864f-f1a050f1aa0e",
    label: "PURASHREE [BENGALI] : SEPTEMBER 2012",
  },
  {
    fileStoreId: "2ef6cca1-1feb-4c2d-ab65-233a25f2c7c0",
    label: "PURASHREE [BENGALI] : JULY 2012",
  },
  {
    fileStoreId: "2d525e4b-0f40-484d-a19f-a90c612e8bad",
    label: "SHARODIA PURASHREE 2012",
  },
  {
    fileStoreId: "5098013f-ca9f-400e-8d9c-a5c5a78e18f4",
    label: "PURASHREE [BENGALI] : MAY 2012",
  },
  {
    fileStoreId: "348c1316-fab7-4c6a-b95c-7d17f70ff219",
    label: "PURASHREE [BENGALI] : APRIL 2012",
  },
  {
    fileStoreId: "c4ba520b-74dc-43a5-8b1f-fd2e7e838e74",
    label: "PURASHREE [BENGALI] : MARCH 2012",
  },
  {
    fileStoreId: "9a122171-5bcd-4a45-8ba3-fb7db9b236c3",
    label: "PURASHREE [BENGALI] : FEBRUARY 2012",
  },
  {
    fileStoreId: "d4e2480d-2cca-47f2-9eed-b04120c8653d",
    label: "PURASHREE [BENGALI] : JANUARY 2012",
  },
  {
    fileStoreId: "084d50a3-5ebd-4486-9f03-3947858b11a8",
    label: "PURASHREE [BENGALI] : DECEMBER 2011",
  },
  {
    fileStoreId: "b48876e7-b250-4594-9e70-eaca885b14ba",
    label: "PURASHREE [BENGALI] : NOVEMBER 2011",
  },
  {
    fileStoreId: "691e6429-6faa-467e-b8e0-2570bbcd682d",
    label: "PURASHREE [BENGALI] : OCTOBER 2011",
  },
  {
    fileStoreId: "9a7db866-110f-4d8e-a06b-022ae0bcad5b",
    label: "SHARODIA PURASHREE 2011",
  },
  {
    fileStoreId: "24baa421-ce64-49e2-b1c0-99a3867e0395",
    label: "PURASHREE [BENGALI] : AUGUST 2011",
  },
  {
    fileStoreId: "9630c3ec-691a-4a31-b548-21e115adb7a9",
    label: "PURASHREE [BENGALI] : JULY 2011",
  },
  {
    fileStoreId: "97afad9b-1cbd-4fad-9ce9-ec77e3611d1e",
    label: "PURASHREE [BENGALI] : MAY 2011",
  },
  {
    fileStoreId: "9a6f3d31-83e0-4fde-a90e-6a879125ed20",
    label: "PURASHREE [BENGALI] : APRIL 2011",
  },
  {
    fileStoreId: "f81134eb-2f04-4c68-9226-790df6be7135",
    label: "PURASHREE [BENGALI] : MARCH 2011",
  },
  {
    fileStoreId: "3fa9031e-4764-4db7-9554-44a052ee4aba",
    label: "PURASHREE [BENGALI] : FEBRUARY 2011",
  },
  {
    fileStoreId: "86df6b36-ae31-4722-9000-9d3a408b181f",
    label: "PURASHREE [BENGALI] : JANUARY 2011",
  },
  {
    fileStoreId: "e2b103e1-17e8-4994-9ff7-049853ae968c",
    label: "PURASHREE [BENGALI] : DECEMBER 2010",
  },
  {
    fileStoreId: "9d6dcb70-2dc7-4b37-9b9b-06fe9ba041be",
    label: "PURASHREE [BENGALI] : NOVEMBER 2010",
  },
  {
    fileStoreId: "e6dae4bf-0e32-4a33-b8b5-00b44e96d62a",
    label: "SHARODIA PURASHREE 2010",
  },
  {
    fileStoreId: "941b5b73-7bfe-4f47-999e-3ccdd33176d1",
    label: "PURASHREE [BENGALI] : SEPTEMBER-OCTOBER 2010",
  },
  {
    fileStoreId: "042b6f67-a02d-431d-8709-76e081928d41",
    label: "PURASHREE SPECIAL ISSUE : AUGUST 2010",
  },
  {
    fileStoreId: "a3766a8c-6922-44cb-a299-68f13f62966b",
    label: "PURASHREE [BENGALI] : AUGUST 2010",
  },
  {
    fileStoreId: "ef9f75ea-b9a7-4736-9825-efddf0b02ec7",
    label: "PURASHREE [BENGALI] : JUNE-JULY 2010",
  },
  {
    fileStoreId: "e9cc97df-32b5-44bd-b948-6af25383af25",
    label: "PURASHREE [BENGALI] : MAY 2010",
  },
  {
    fileStoreId: "af2c6287-9670-4f7c-b55a-9eb1c5060262",
    label: "PURASHREE [BENGALI] : APRIL 2010",
  },
  {
    fileStoreId: "d7f75842-dd82-4838-b523-3d0814b60468",
    label: "PURASHREE [BENGALI] : MARCH 2010",
  },
  {
    fileStoreId: "a32f60bf-df86-4802-a560-8f2b476aee21",
    label: "PURASHREE [HINDI] : MARCH 2010",
  },
  {
    fileStoreId: "d01f4c88-17c3-4cfa-9066-f238320ef752",
    label: "PURASHREE [URDU] : MARCH 2010",
  },
  {
    fileStoreId: "95698162-2459-4efc-ba2b-a828af7b6c21",
    label: "KALLOLINI KOLKATA",
  },
  {
    fileStoreId: "302b7bb7-9e2f-4c61-b89b-77cc16494132",
    label: "PURASHREE [BENGALI] : FEBRUARY 2010",
  },
  {
    fileStoreId: "6187f972-4dd4-49d9-b142-8d966c5be4db",
    label: "PURASHREE [BENGALI] : JANUARY 2010",
  },
  {
    fileStoreId: "e98afa00-310a-4cb9-9aec-ce7c08e4adc9",
    label: "PURASHREE [BENGALI] : DECEMBER 2009",
  },
  {
    fileStoreId: "84e420e3-62cb-4b61-ae3f-92a7350cf62a",
    label: "PURASHREE [BENGALI] : NOVEMBER 2009",
  },
  {
    fileStoreId: "14f78efc-0896-4da5-81dd-bae12ac32da6",
    label: "PURASHREE [BENGALI] : OCTOBER 2009",
  },
  {
    fileStoreId: "1c33622d-8b0c-4d82-b3d2-566f5940792d",
    label: "PURASHREE [BENGALI] : SEPTEMBER 2009",
  },
  {
    fileStoreId: "f6d7911e-16b8-45c9-bf6f-bb27b0eb923b",
    label: "PURASHREE [BENGALI] : AUGUST 2009",
  },
  {
    fileStoreId: "bc02966b-2829-4e81-a464-04bcb492d054",
    label: "PURASHREE [BENGALI] : JULY 2009",
  },
  {
    fileStoreId: "9ced0ced-b290-456d-9693-868fa21cb1b9",
    label: "PURASHREE [BENGALI] : JUNE 2009",
  },
  {
    fileStoreId: "48301ef6-51f7-411d-8d0d-32ae754dabca",
    label: "PURASHREE [BENGALI] : MAY 2009",
  },
  {
    fileStoreId: "1e726091-5760-40b5-927b-d3145956ea74",
    label: "PURASHREE [BENGALI] : APRIL 2009",
  },
];

const Archive = () => (
  <TableStructure heading={"KMC Publications"} list={List} />
);

export default Archive;
